// Local imports from cloned components
// Phase 1: HeaderBlock and ContentBlock are now standalone
// Phase 2: FooterBlock will be added later
import HeaderBlock from "../components/blocks/core/HeaderBlock";
import ContentBlock from "../components/blocks/core/ContentBlock";
import FooterBlock from "../components/blocks/core/FooterBlock";

export const BLOCK_COMPONENTS = {
  HeaderBlock,
  ContentBlock,
  FooterBlock,
  // Note: Other blocks (UserProfileBlock, WalletBlock, etc.) are not needed for landing page
} as const;
